module.exports = "/images/info_green_btn.png?a20368cc2b279dd185ed876071899e57";